import * as React from 'react';
import { ActionBar } from '@core/ui';
import * as Icons from '@ant-design/icons';
import { Dropdown, Menu, Space } from 'antd';

import { HeaderButton, HeadPortal } from '@modules/layout';

import { usePartnerDeclarationsActionBar } from '../hooks';
import { CurrencySymbols } from '@infra/utils';

export const PartnerDeclarationsActionBar = () => {
  const { selection, resetSelection, selectAll, fetch, reset, exportAsExcel, exportMiniAsExcel, state } = usePartnerDeclarationsActionBar();

  const selectAllButton = (
    <HeaderButton onClick={selectAll} icon={<Icons.CheckCircleOutlined />}>
      Hamısını seç
    </HeaderButton>
  );

  const resetSelectionButton = (
    <HeaderButton onClick={resetSelection} icon={<Icons.CloseCircleOutlined />}>
      {selection.length} sətir | Çatdırılma: ({CurrencySymbols.USD}
    </HeaderButton>
  );

  return (
    <HeadPortal>
      <ActionBar $flex={true}>
        <Space size={0}>
          {!selection.length ? selectAllButton : resetSelectionButton}
          <HeaderButton onClick={fetch} icon={<Icons.ReloadOutlined />}>
            Yenilə
          </HeaderButton>
          <HeaderButton onClick={reset} icon={<Icons.ClearOutlined />}>
            Sıfırla
          </HeaderButton>
          <HeaderButton>Cəmi: {state.total}</HeaderButton>
        </Space>
        {!selection.length && (
          <Space size={0}>
            <Dropdown
              trigger={['click']}
              overlay={
                <Menu>
                  <Menu.Item onClick={exportAsExcel} icon={<Icons.FileExcelOutlined />}>
                    Export
                  </Menu.Item>
                  <Menu.Item onClick={exportMiniAsExcel} icon={<Icons.FileExcelOutlined />}>
                    Mini Export
                  </Menu.Item>
                </Menu>
              }
            >
              <HeaderButton icon={<Icons.DownCircleOutlined />}>Digər</HeaderButton>
            </Dropdown>
          </Space>
        )}
      </ActionBar>
    </HeadPortal>
  );
};
